<template>
    <v-footer inset padless  tile color="grey lighten-5">
        <v-card width="600px" outlined color="grey lighten-5" class="mx-auto">
            <v-row dense>
                <v-col>
                    <v-img :src="require('../assets/BANNER_MDT_ETPA2.jpg')" aspect-ratio="8" contain alt=""></v-img>
                </v-col>
            </v-row>
            <p style="text-align:center;" class="body-2 text--primary">
                &copy;2022 — <strong>Εύδοξος</strong></p>
        </v-card>
    </v-footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>